export type PickupPoint = {
  id: string;
  shortName: string;
  name: string;
  address: string;
  hours: string;
  eta: string;
  rating?: string;
  lat: number;
  lng: number;
  active: boolean;
  note?: string;
};

export const pickupPoints: PickupPoint[] = [
  {
    id: "naberezhnaya-bridge",
    shortName: "Набережная · за мостом",
    name: "CoffeeTrack · Набережная · за мостом",
    address: "Набережная Туры · за мостом",
    hours: "12:00–01:00",
    eta: "7–10 мин",
    rating: "4,9",

    // Временные координаты по присланной Яндекс.Карте.
    lat: 57.164624,
    lng: 65.523217,

    active: true,
  },

  {
    id: "naberezhnaya-square",
    shortName: "Набережная · у сквера",
    name: "CoffeeTrack · Набережная · у сквера",
    address: "Набережная Туры · Исторический сквер",
    hours: "12:00–01:00",
    eta: "7–10 мин",
    rating: "4,9",

    // Временные координаты по присланной точке 2ГИС.
    // Потом подвинем метку буквально до нужного места.
    lat: 57.161617,
    lng: 65.523956,

    active: true,
  },
];

export const defaultPickupPoint = pickupPoints[0];
